module.exports = __webpack_public_path__ + "img/chrom.4d052516.png";